import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { TAGS_STATUS_OPTIONS, TagsStatusLabel } from "../../types/alerts";

interface TagsStatusSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export default function TagsStatusSelect({
  value,
  onChange,
  disabled = false,
}: TagsStatusSelectProps) {
  return (
    <FormControl size="small" fullWidth disabled={disabled}>
      <InputLabel id="tags-status-label">Tags Status</InputLabel>
      <Select
        labelId="tags-status-label"
        id="tags-status"
        value={value}
        label="Tags Status"
        onChange={(e) => onChange(e.target.value)}
      >
        {TAGS_STATUS_OPTIONS.map((status) => (
          <MenuItem key={status} value={status}>
            {TagsStatusLabel[status]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
